import type { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useSendOTP = () =>
  useMutation({
    mutationFn: sendOTP,
  });

const sendOTP = async (params: SendOTPBody) =>
  api.post<SendOTPResponse, AxiosResponse<SendOTPResponse>, SendOTPBody>(
    apiConfig.routes.auth.sendOTP,
    params
  );

export type SendOTPBody = {
  identifier: string;
  otp_type: 'email' | 'phone';
};

type SendOTPResponse = {
  expires_in: number;
  resend_available_in: number;
};
